import { z } from 'zod';
export const ContactsParameterSchema = z.enum(['CONTACTS_BASE_URL']);
export const ContactsParameterEnum = ContactsParameterSchema.enum;
